import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles, Typography } from '@material-ui/core';
import { palette } from '../../../../../../../settings/themes/colors';
import { DynamicBlock } from './DynamicBlock';

const useStyles = makeStyles({
  sectionTitle: {
    color: palette.captudataBlue,
    fontFamily: 'Nunito',
    fontSize: 26,
    fontWeight: 900,
    letterSpacing: '0.45px',
    lineHeight: 1,
    marginTop: 32
  }
});

export const DynamicSection = ({ section, blocks }) => {
  const classes = useStyles();

  return (
    <>
      <Typography variant="h5" className={classes.sectionTitle}>
        {section.title}
      </Typography>
      {(blocks || []).map(block => (
        <DynamicBlock key={block.key} block={block} />
      ))}
    </>
  );
};

DynamicSection.propTypes = {
  section: PropTypes.shape({
    key: PropTypes.string,
    title: PropTypes.string
  }).isRequired,
  blocks: PropTypes.array.isRequired
};
